<!-- 文章管理 -->
<template>
  <div class="all-main">
      <div class="search-form">
      <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline">
          <el-form-item label="主标题:">
              <el-input v-model="formInline.mainTitle" placeholder="请输入主标题"></el-input>
          </el-form-item>
          <el-form-item label="类型:" prop="type">
            <el-select v-model="formInline.type" placeholder="请选择文章类型">
                <el-option label="新闻动态" value="1"></el-option>
                <el-option label="企业资质" value="2"></el-option>
                <el-option label="荣誉证书" value="3"></el-option>
                <el-option label="新闻播报" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始结束时间:">
            <el-date-picker
              v-model="arr"
              type="daterange"
              value-format="yyyy-MM-dd hh:mm:ss"
              format="yyyy-MM-dd hh:mm:ss"
              @change="choseDate"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
          <el-button type="primary" @click="onSubmit" size="mini" icon="el-icon-search">查询</el-button>
          <el-button @click="resetForm('formInline')" size="mini" icon="el-icon-refresh-right">重置</el-button>
          </el-form-item>
      </el-form>
      </div>
      <div class="btn">
      <el-button type="text" style="font-size: 14px;" class="add-btn" @click="add"><i class="el-icon-plus"></i>&nbsp;新增</el-button>
      </div>
      <div class="table-show">
      <template>
          <el-table
          :data="infoByPageList"
          border
          :highlight-current-row = true
          style="width: 100%">
          <el-table-column prop = "" label="编号" min-width="5%" fixed="left" align="center">
              <template scope="scope">
              <span>{{(formInline.pageNum - 1) * formInline.pageSize + scope.$index + 1}}</span>
              </template>
          </el-table-column>
          <el-table-column
              prop="mainTitle"
              align="center"
              label="主标题"
              min-width="15%"
              >
          </el-table-column>
          <el-table-column
              prop="subTitle"
              align="center"
              label="副标题"
              min-width="10%"
              >
          </el-table-column>
          <el-table-column
              prop="introduction"
              align="center"
              min-width="20%"
              label="文章简介">
          </el-table-column>
          <el-table-column
              prop="coverImg"
              align="center"
              min-width="20%"
              label="封面图片">
          </el-table-column>
          <el-table-column
            prop="type"
            align="center"
            min-width="10%"
            label="文章类型">
            <template slot-scope="scope">
                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.type == '1'">新闻动态</el-tag>
                <el-tag type="success" effect="dark" size="mini" v-if="scope.row.type == '2'">企业资质</el-tag>
                <el-tag type="danger"  effect="dark" size="mini" v-if="scope.row.type == '3'">荣誉证书</el-tag>
                <el-tag type="danger"  effect="dark" size="mini" v-if="scope.row.type == '4'">新闻播报</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column
              prop="coverImg"
              align="center"
              min-width="30%"
              label="文章内容">
          </el-table-column> -->
          <el-table-column
              prop="publicationDate"
              align="center"
              min-width="8%"
              :formatter="formatDate"
              label="发布日期">
          </el-table-column>
          <el-table-column
          fixed="right"
          align="center"
          label="操作"
          min-width="9%">
          <template slot-scope="scope">
              <span class="btn">
                  <el-button @click="handleClick(scope.row)" type="text" style="font-size: 14px;" size="small">编辑</el-button>
              </span>
              <span class="btn">
                  <el-button @click="del(scope.row)" type="text" style="font-size: 14px;" size="small">删除</el-button>
              </span>
          </template>
          </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formInline.pageNum"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="formInline.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="infoByPageToTal">
          </el-pagination>
          </div>
      </template>
      </div>
      <articleDialogVue :boxShow="boxShow" :formInline="formInline" ref="teamcardDialog"></articleDialogVue>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
// 引入新增dialog
import articleDialogVue from '@/components/system/articleDialog.vue'
  export default {
  components:{
      articleDialogVue
  },
  name:'employeeInformation',
  data(){
  return{
          formInline:{
              pageNum:1,
              pageSize:15,
              mainTitle:null,
              type:null,
              beginTime:null,
              endTime:null,
          },
          arr:null,
          boxShow:{
              isShow:false,
              flag:0,
          },
      }
      },
      computed:{
          ...mapState('article',['infoByPageToTal','pageInfo','infoByPageList'])
      },
      created(){
        this.getInfoBypageAction(this.formInline)
      },
  methods:{
      ...mapActions('article',['getInfoBypageAction','delAction']),
      // 点击选择开始结束时间选择框
      choseDate(){
        if (this.arr !== null) {
          this.formInline.beginTime = this.arr[0]
          this.formInline.endTime = this.arr[1]
        }
      },
      // 处理获取得到的时间2023-01-01 00:00:00  显示在表格为2023-01-01
      formatDate(row, column, cellValue, index) {  
        // 假设cellValue是日期字符串，如'2024-09-06 00:00:00'  
        // 使用split和slice方法来获取年月日
        // 如果有值
        if (cellValue != null) {
          const dateParts = cellValue.split(' ')[0].split('-');  
          // 返回格式化后的字符串  
          return `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;  
        }
        return null;
      },
      // 点击查询按钮
      onSubmit(){
          this.pageInfo.pageNum = 1
          this.getInfoBypageAction(this.formInline)
      },
      // 点击重置按钮
      resetForm(formInline){
          this.$refs[formInline].resetFields();
          this.formInline.pageNum = 1,
          this.formInline.pageSize = 15,
          this.formInline.mainTitle = null,
          this.formInline.type = null,
          this.formInline.beginTime = null,
          this.formInline.endTime = null,
          this.arr = null
          this.getInfoBypageAction(this.formInline)
      },
      // 点击编辑按钮
      handleClick(row){
          this.$refs.teamcardDialog.form = {...row}
          this.$refs.teamcardDialog.html = row.content
          this.$refs.teamcardDialog.src = row.coverImg
          this.boxShow.flag = 1
          this.boxShow.isShow = true
      },
      // 点击新增按钮
      add(){ 
          this.boxShow.flag = 0
          this.boxShow.isShow = true
      },
        // 点击删除按钮
        del(row){
            var ids = [row.id]
            this.$confirm('确定要删除该数据吗?',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                type:'warning',
            }).then(()=>{
                this.delAction(ids)
            }).catch(()=>{

            })
        },
      // 分页时修改每页的行数，这里会自动传入一个size
      handleSizeChange(size) {
          // 修改当前每页的数据行数
          this.formInline.pageSize = size
          // 数据重新分页
          this.getInfoBypageAction(this.formInline)
      },
      // 调整当前页码
      handleCurrentChange(pageNumber) {
          // 修改当前页码
          this.formInline.pageNum = pageNumber
          // 数据重新分页
          this.getInfoBypageAction(this.formInline)
      },
        // 更新pageInfo
        updatePageInfo() {
            this.$set(this.pageInfo, 'pageNum', this.formInline.pageNum);
            this.$set(this.pageInfo, 'pageSize', this.formInline.pageSize);
            this.$set(this.pageInfo, 'mainTitle', this.formInline.mainTitle);
            this.$set(this.pageInfo, 'type', this.formInline.type);
            this.$set(this.pageInfo, 'beginTime', this.formInline.beginTime);
            this.$set(this.pageInfo, 'endTime', this.formInline.endTime);
        },
        // 更新forminline
        updateFormInLine() {
            this.$set(this.formInline, 'pageNum', this.pageInfo.pageNum);
            this.$set(this.formInline, 'pageSize', this.pageInfo.pageSize);
            this.$set(this.formInline, 'mainTitle', this.pageInfo.mainTitle);
            this.$set(this.formInline, 'type', this.pageInfo.type);
            this.$set(this.formInline, 'beginTime', this.pageInfo.beginTime);
            this.$set(this.formInline, 'endTime', this.pageInfo.endTime);
        },
  },
   // 或者在watch选项中监听formInline的变化
  watch: {
      formInline: {
      handler() {
          this.updatePageInfo();
      },
      deep: true // 如果formInline的属性值是嵌套的对象，需要设置为true以递归监听
  },
  pageInfo: {
      handler() {
          this.updateFormInLine();
      },
      deep: true // 如果formInline的属性值是嵌套的对象，需要设置为true以递归监听
      },
  }
}
</script>

<style scoped>
.all-main{
  text-align: left;
  background-color: #fff;
  margin: 5px 5px !important;
}
.search-form{
  padding: 2px 20px;
}
::v-deep .el-input__inner{
  height: 30px !important;
  line-height: 30px !important;
  /* padding: 0px !important; */
}
::v-deep .el-date-editor .el-range-separator,
::v-deep  .el-date-editor .el-range__icon{
  line-height: 17px !important;
}
::v-deep .el-form-item{
  margin-bottom: 0px;
}
/* 表格 */
::v-deep .el-table .el-table__cell{
  padding: 0 !important;
}
.tag{
  color:#40a9ff ;
}

/* 高亮当前行 */
::v-deep .el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell{
  background-color: #d0e6f7;
}
/* 展开收起 */
.close{
  color: #40a9ff;
  display: none;
  cursor: pointer;
}
.open{
  color: #40a9ff;
  cursor: pointer;
}
/* 按钮样式 */
.add-btn{
  margin: 5px 15px;
}
/* 分页 */
.pagination{
  padding: 20px 50px;
  text-align: center;
}
/* 按钮下拉菜单 */
.el-dropdown-link{
  margin: 0 5px !important;
  color: #66b1ff;
}
.btn{
  margin: 0 3px !important;
}
.el-button--text{
  font-size: 14px !important;
}
</style>